<template>
  <popup class="trend-popup" :close-action="closePopup" :title="popupTitle">
    <template v-slot:content>
      <card class="trend-card" :has-content-padding="false">
        <bar-graph v-if="graphData" :with-sign='false' :graph-height="102" :bar-values="barValues"/>
      </card>
      <div v-if="isPresentingCurrentMonth">
        <div class="prediction-text">הצפי לחודש {{ monthFullName }} הוא: <span class="bold">{{predictedAmount }} ₪</span></div>
      </div>
      <expandable-section header-text="איך זה מחושב?" class="expandable-container" @expand-change="logExpandChanged">
        <template v-slot:content>
          <div class="category-reason">
            הוצאות שהמערכת זיהתה כהפקדות לחיסכון או כאלה שבחרת להעביר בעצמך.
          </div>
        </template>
      </expandable-section>
      <div>
        <riseup-button :action="closePopup"
                       variant="primary"
                       title="הבנתי, תודה"
                       :size="'slim'"/>
      </div>
    </template>
  </popup>
</template>

<script>
import BaseUI from 'base-ui';
import { mapGetters } from 'vuex';
import BarGraph from '@/base-components/bar-graph/BarGraph';
import moneyUtils from '@/utils/money';
import cashflowViewConsts from '@/constants/cashflow-view';
import { getEnvelopeTrendValues } from './cashflow-trends';
import CashflowTrends from './CashflowTrendsMixin';

export default {
  name: 'SavingsCashflowTrend',
  components: {
    Popup: BaseUI.Popup,
    Card: BaseUI.Card,
    ExpandableSection: BaseUI.ExpandableSection,
    RiseupButton: BaseUI.RiseupButton,
    BarGraph,
  },
  mixins: [CashflowTrends],
  data() {
    return {
      trendType: 'Savings',
    };
  },
  created() {
    this.trackCashflowTrendsOpened(this.trendType);
  },
  computed: {
    ...mapGetters('cashflowView', ['predictedBalanceAtEndOfMonth', 'monthFullName']),
    graphData() {
      return getEnvelopeTrendValues(this.allCashflows, this.presentedBudgetDate, this.getSavingsTrendValuesForCashflow);
    },
    barValues() {
      return this.graphData ?? [];
    },
    savingExpenses() {
      return this.cashflowUITree[cashflowViewConsts.cashflowTypes.fixedSaving];
    },
    oneTimeSaving() {
      return this.cashflowUITree[cashflowViewConsts.cashflowTypes.oneTimeSaving][0];
    },
    predictedAmount() {
      return moneyUtils.formatAmountWithFraction(
        this.savingExpenses.recommendedOrExpectedAmount + this.oneTimeSaving.recommendedOrExpectedAmount, 0,
      );
    },
    popupTitle() {
      return 'הפקדות לחיסכון לפי חודשים';
    },
  },
  methods: {
    getSavingsTrendValuesForCashflow(cf, index) {
      const actuals = cf.fixedTree.fixedSavingEnvelopesActualSum + cf.oneTimeSavingActualSum;
      const prediction = cf.fixedTree.fixedSavingEnvelopesBalanceSum + cf.oneTimeSavingActualSum;
      return {
        value: actuals,
        secondaryValue: (index === 0 && this.isPresentingCurrentMonth) ? prediction : undefined,
        color: index === 0 ? BaseUI.Colors.riseupDangerRed : BaseUI.Colors.riseupDangerLightRed,
        focused: index === 0,
      };
    },
    closePopup() {
      this.closeCashflowTrendPopup(this.trendType);
    },
    logExpandChanged(newValue) {
      this.logCashflowTrendExpandChanged(this.trendType, newValue);
    },
  },
};
</script>

<style scoped lang="scss">
@import "cashflow-trends.styles";
</style>
